import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { AuthGuard } from './auth.guard';
import { AlcanceTitulosComponent } from './modules/general/alcance-titulos/alcance-titulos.component';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';
import { UniversidadComponent } from './modules/login/universidad/universidad.component';
import { HistorialComponent } from './modules/general/historial/historial.component';




export const routes: Routes = [
  {
    path: '',
    redirectTo: 'expedientes',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
  path: 'universidad',
  component: UniversidadComponent,
  },
  {
    path: 'alcanceTitulos',
    component: AlcanceTitulosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'historial/:idtitulo/:idtipotitulo',
    component: HistorialComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'titulos',
    canActivate: [AuthGuard],
    loadChildren: './modules/titulos/titulos.module#TitulosModule'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: FullLayoutComponent,
    data: {
      title: 'Inicio'
    },
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'convocatorias',
        canActivate: [AuthGuard],
        loadChildren: './modules/convocatorias/convocatorias.module#ConvocatoriasModule'
      },
        {
          path: 'expedientes',
          canActivate: [AuthGuard],
          loadChildren: './modules/expedientes/expedientes.module#ExpedientesModule'
        },

    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /app/src/app/app.routing.ts